import type * as React from 'react';

import type * as api from '@gitbook/api-client';
import type { NavigationScreenSpaceState } from '@gitbook/app-navigation';
import { Button, type ButtonProps } from '@gitbook/spine-react';

import { DotIndicator } from './DotIndicator';

/**
 * Button to open the change requests side sheet.
 */
export function ChangeRequestsButton(
    props: {
        space: api.Space;
        screen: NavigationScreenSpaceState;
    } & Omit<ButtonProps, 'onPress'>
): React.ReactElement {
    const { space, screen, ...rest } = props;
    return (
        <Button
            {...rest}
            trailingIcon={
                space.changeRequestsOpen || space.changeRequestsDraft
                    ? () => <DotIndicator disabled={props.disabled} />
                    : undefined
            }
            active={screen.sideSheet?.type === 'change-requests'}
            href={{
                screen: {
                    sideSheet:
                        screen.sideSheet?.type === 'change-requests'
                            ? undefined
                            : {
                                  type: 'change-requests',
                                  tab: space.changeRequestsOpen > 0 ? 'open' : 'draft',
                              },
                },
            }}
        />
    );
}
